




































import { parse, CurrencyDirective } from 'vue-currency-input';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  directives: { currency: CurrencyDirective }
})
export default class NumberField extends Vue {
  @Prop(String) public label;
  @Prop({ type: String, default: '' }) public readonly info!: string;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop(String) public readonly labelCols!: string;
  @Prop(String) public readonly inputCols!: string;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop(String) public readonly prefix!: string;
  @Prop(String) public readonly suffix!: string;

  @Prop({ type: String, default: null }) public readonly currency!: string;
  @Prop({ type: Number, default: 2 }) public readonly precision!: number;
  @Prop({ type: Number, default: undefined }) public readonly minValue!: number;
  @Prop({ type: Number, default: undefined }) public readonly maxValue!: number;

  // https://vue-currency-input-v1.netlify.app/config/#component
  public options = {
    locale: 'nl-NL',
    currency: this.currency,
    valueRange: { min: this.minValue, max: this.maxValue },
    precision: this.precision
  };

  public formattedValue = this.formatValue();

  public formatValue() {
    if (this.rec && this.rec[this.field] != null) {
      if (this.currency === 'EUR') {
        return Vue.filter('euro')(this.rec[this.field]);
      } else {
        return Vue.filter('number')(this.rec[this.field]);
      }
    }
    return '';
  }

  public updateRec(e) {
    const oldValue = this.rec[this.field];
    this.rec[this.field] = parse(this.formattedValue, this.options);
    if (oldValue !== this.rec[this.field]) {
      // Only emit change if the value changed
      this.$emit('change', e);
    }
  }

  @Watch('rec') public valueChanged(newValue, oldValue) {
    // Initialized
    if (oldValue[this.field] !== this.rec[this.field]) {
      this.formattedValue = this.formatValue();
    }
  }
}
